/**
 * Shared predicates for Clerk error shapes.
 *
 * Clerk's single-session-mode throws `session_exists` in two shapes:
 *   { errors: [{ code: 'session_exists' }], ... }   — standard ClerkError
 *   { code: 'session_exists', ... }                  — some SDK paths / catch wrappers
 */

/**
 * Returns true if `err` represents a Clerk "session already exists" error.
 * Use this to short-circuit sign-in/sign-up flows when the user is already
 * authenticated — the correct recovery is to navigate to "/" rather than
 * showing an error message or retrying.
 */
export function isSessionExists(err: unknown): boolean {
  const e = err as { errors?: Array<{ code?: string }>; code?: string } | null | undefined;
  if (!e) return false;
  if (e.errors?.[0]?.code === 'session_exists') return true;
  if (e.code === 'session_exists') return true;
  return false;
}
